import AssociationSignup from './AssociationSignup.page';

export default AssociationSignup;